import React from 'react';
import RWDPageLayout from '../../component/composite/RWDPageLayout';
export default function View() {
    return <RWDPageLayout isLoading/>;
}
